import i18n from "i18n";

const tagsItems = [
  {
    title: i18n.t("generate.and.print.tags"),
    arrow: true,
    to: "/admin/tags/print",
    permission: 'read_config_tag',
  },
  {
    title: i18n.t("reprint.tags"),
    arrow: true,
    to: "/admin/tags/reprint",
    permission: 'read_config_tag',
  },
  {
    title: i18n.t("traceability"),
    arrow: true,
    to: "/admin/tag-traceability",
    permission: 'read_config_tag',
  },
  {
    title: i18n.t("tag.association"),
    arrow: true,
    to: "/admin/tags/associate",
    permission: 'read_config_tag',
  },
  {
    title: i18n.t("template.tags"),
    arrow: true,
    to: "/admin/config_tags",
    permission: 'read_config_tag',
  }
];

export const stepTags = {
  items: tagsItems,
  headerTitle: i18n.t("Tags"),
  navHidden: false,
  goBackTo: 0,
};